import { MessageContainerComponent } from "./messageContainer";

export const MessageContainer = MessageContainerComponent;
